<template>
  <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
    <template #trigger>
      <p
        v-if="
          !user.personalInfo ||
            (!user.personalInfo.name && !user.personalInfo.surname)
        "
      >
        {{ user._id }}
      </p>

      <button class="button is-light" slot="trigger" @click.stop v-else>
        {{
          `${
            user.accountInfo && user.accountInfo.isTotemAccount
              ? "Totem - "
              : ""
          }`
        }}
        {{ getSocialName ? getSocialName : getUserName }}
      </button>
    </template>

    <b-dropdown-item aria-role="listitem">
      <b>{{ $t("common.name") }}: </b>
      {{ getUserName }}
    </b-dropdown-item>

    <b-dropdown-item aria-role="listitem" v-if="getSocialName">
      <b>{{ $t("common.socialName") }}: </b>
      {{ getSocialName }}
    </b-dropdown-item>

    <b-dropdown-item aria-role="listitem" v-if="getUserEmail != ''">
      <b>{{ $t("common.email") }}: </b>
      <a :href="`mailto:${getUserEmail}`" target="_blank">
        {{ getUserEmail }}
      </a>
    </b-dropdown-item>

    <b-dropdown-item aria-role="listitem" v-if="getUserPhone">
      <b>{{ $t("transactions.cell") }}: </b>
      <a
        :href="
          `https://wa.me/${cellphoneWithCountryCallingCode(
            getUserPhone
          ).replace(/\D/g, '')}`
        "
        target="_blank"
      >
        {{ cellphoneWithCountryCallingCode(getUserPhone) }}
        <img
          src="../../../assets/img/logo-whatsapp.png"
          alt=""
          style="position: relative; top: 4px; left: 4px;"
        />
      </a>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mask } from "../../../mixins/mask";

export default {
  props: ["user", "invoiceUser"],

  mixins: [mask],

  computed: {
    getSocialName() {
      let personalInfo = this.user.personalInfo;

      if (this.invoiceUser && this.invoiceUser.socialName) {
        personalInfo = this.invoiceUser;
      }

      if (
        personalInfo.socialName &&
        personalInfo.socialName != personalInfo.name
      ) {
        return personalInfo.socialName;
      }

      return "";
    },

    getUserName() {
      let name = "NÃO IDENTIFICADO";
      let personalInfo = this.user.personalInfo;

      if (this.invoiceUser && this.invoiceUser.name) {
        personalInfo = this.invoiceUser;
      }

      let surname =
        personalInfo && personalInfo.surname ? personalInfo.surname : "";

      if (personalInfo.name == surname) surname = "";

      name = `${personalInfo.name} ${surname}`;

      return name;
    },

    getUserEmail() {
      if (this.user) {
        let personalInfo = this.user.personalInfo;

        if (this.invoiceUser && this.invoiceUser.email) {
          personalInfo = this.invoiceUser;
        }

        if (personalInfo.email !== personalInfo.name) return personalInfo.email;
      }
      return "";
    },

    getUserPhone() {
      if (this.user) {
        let personalInfo = this.user.personalInfo;

        if (this.invoiceUser && this.invoiceUser.cellphone) {
          personalInfo = this.invoiceUser;
        }

        if (personalInfo.cellphone !== personalInfo.name) return personalInfo;
      }
      return null;
    }
  }
};
</script>
